import { getProvidersData } from '../../helpers/data-helper';

export default {
	data: function() {
		return {
			providers_data: {},
			providers: [],
			providers_name: [],
		}
	},
	props: ['filters'],
	watch: {
		filters: {
			handler(new_val, old_val) {
				console.log(new_val)
				this.filterProviders();
			},
			deep: true
		}
	},
	mounted: function() {
		this.providers_data = getProvidersData();
		// this.data = this.providers_data;

		for(var key in this.providers_data) {
			this.providers.push(key);
		}
		this.providers_name = this.providers;
	},
	methods: {
		filterProviders: function() {
			this.providers = [];
			for (var i = 0 ; i < this.providers_name.length; i++) {
				let provider = this.providers_name[i];
				let valid = true;
				for (var key in this.filters) {
					if (this.filters[key] && this.filters[key].length && valid) {
						switch(key) {
							case 'price':
								let filter_price = this.filters[key];
								filter_price = filter_price.split("-");
								filter_price[0] = parseFloat(filter_price[0]);
								filter_price[1] = parseFloat(filter_price[1]);

								let provider_price = this.providers_data[provider].price;
								provider_price = parseFloat(provider_price);

								if (provider_price < filter_price[0] || provider_price > filter_price[1]){
									valid = false;
								} 
								break;
							case 'installation_type':
								if (this.providers_data[provider][key] != this.filters[key]) {
									valid = false;
								}
								break;
							case 'home_type':
							case 'user_type':
								let mat = true;
								for(let f = 0; f < this.filters[key].length; f++) {
									let feature = this.filters[key][f];
									if (this.providers_data[provider][key].indexOf(feature) < 0) {
										mat = false;
									}
								}
								valid = mat;
								break;
							case 'features':
								let matched = true;
								for(let f = 0; f < this.filters[key].length; f++) {
									let feature = this.filters[key][f];
									// console.log(provider, feature, this.providers_data[provider][key][feature])
									if (this.providers_data[provider][key][feature] == false && matched) {
										matched = false;
									}
								}
								valid = matched;
								break;
						}
					}
				}

				if (valid) {
					this.providers.push(provider);
				}	
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/common/Features/features.js